import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsCreatePageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);
        //Alert, Contact, $http, locale, NavService, ResourceCommon, $state, $stateParams, Deposit, $rootScope, Acl, Users
        this.stateParams = this.injector.get('$stateParams');
        this.state = this.injector.get('$state');
        this.usersStore = this.injector.get('Users');
        this.resourceCommon = this.injector.get('ResourceCommon');
        this.locale = this.injector.get('locale');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.navigator = this.injector.get('NavService');
        this.rootScope = this.injector.get('$rootScope');
        this.acl = this.injector.get('Acl');
        this.depositService = this.injector.get('Deposit');

        this.uploader = this.resourceCommon.uploadImage;
        this.store = this.stateParams.store;

        this.mediaDirectoryUuid = _.get(this.usersStore, 'state.company.media.default_directories.contacts', null);

        this.deposits = {
            countries: {},
            languages: {},
            genders: {}
        };

        this.injector.get('Contact')
            .getSchema()
            .then(schema => {
                this.schema = schema;
                _(this.schema.properties)
                    .pickBy({type: 'boolean'})
                    .map((prop, key) => {
                        this.model[key] = 0;
                    })
                    .value();
                this.model.addressbook = 1;
                this.model.business_preferred = false;
            });

        this.model = {
            country: 'DE',
            business_country: 'DE',
            language: 'DE',
            sex: 'unknown'
        };

        this._loadDeposits();
        this.headline = 'Create new contact';
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;

            if (_.isUndefined(this.deposits.genders[this.model.sex])) {
                this.model.sex = _.first(Object.keys(this.deposits.genders));
            }
        });
    }

    save(model, form) {
        if (!form.$valid) {
            this.alert.error('Invalid data', 'Please recheck your inputs');
            return;
        }

        this.locale.ready('sweetalerts').then(() => {
            this.api.post('contacts', this.prepareModelForApi(model))
                .then(response => {
                    this.model = response.data.data;

                    this.alert.success(this.locale.getString('sweetalerts.records_saved'), this.locale.getString('sweetalerts.records_saved_message'));
                    this.cancel();
                }, response => {
                    this.alert.handle(response);
                });
        });
    }

    prepareModelForApi(model) {
        const out = _.cloneDeep(model);

        for (let i = 1; i <= 40; i++) {
            const currentField = _.get(this.schema.properties, 'custom_' + i, null);
            if (currentField) {
                if ((currentField.original.type === 'date' || currentField.original.type === 'datetime') && !_.get(out, 'custom_' + i)) {
                    out['custom_' + i] = null;
                }
            }
        }

        return out;
    }

    cancel() {
        return this.navigator.goBack();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/create.js